import { Box } from "@mui/material";

export function ContentBox({children}){
    return <Box sx={{width:"100%",display:"flex",flexDirection:"row",flex:1,flexWrap:"wrap"}}>{children}</Box>
}